import React from "react";
import PostBanner from "@/components/pages/blog/post-banner";
import RelatedPosts from "@/components/pages/blog/related-posts";
import Social from "@/components/pages/blog/social";
import { m } from "framer-motion";
import { getUrqlClient } from "@/lib/urql-client";
import {
  QUERY_ALL_BLOGS_SELECTIVE,
  QUERY_BLOG_BY_SLUG,
} from "@/framework/queries/blogs";
import { sanitize } from "@/framework/utils/sanitize";
import { fadeIn } from "@/utils/motion/fade-in";
import Seo from "@/utils/seo";
export default function Post({ blog, relatedPosts }) {
  const seo = {
    slug: `blog-${blog?.slug}`,
    metaTitle:
      blog?.seo?.metaTitle ??
      "Interior Design Projects | Chalk Studio Portfolio",
    metaDescription:
      blog?.seo?.metaDescription ??
      blog?.shortDescription ??
      "Browse our portfolio of inspired interiors. Chalk Studio’s projects reflect timeless design, functionality, and personalized creativity.",
  };
  return (
    <>
      <Seo seo={seo} />
      <PostBanner blog={blog} />
      {blog?.content && (
        <m.div
          initial={"from"}
          whileInView={"to"}
          variants={fadeIn(0.75, 0.25)}
          viewport={{ once: true }}
          className="flex flex-col w-full md:p-8 p-4 !py-16 mx-auto max-w-[1080px]"
          id="post-content"
          dangerouslySetInnerHTML={{ __html: blog?.content }}
        ></m.div>
      )}
      <Social blog={blog} />
      {relatedPosts && (
        <RelatedPosts
          title="Read More Like this"
          showSubscribe={false}
          data={relatedPosts}
          showNavAbove={true}
          showButton={true}
          buttonText="View More Edits"
          buttonLink={"/blogs"}
        />
      )}
    </>
  );
}

// export async function getStaticProps({ params = {} } = {}) {
//   let props = {};
//   const client = await getUrqlClient();

//   try {
//     const { data } = await client.query(
//       QUERY_BLOG_BY_SLUG,
//       {
//         slug: params?.slug.replace("blog-", ""), // Remove `blog-` prefix
//       },
//       {
//         requestPolicy: "network-only",
//       }
//     );

//     if (!data?.blog?.data) {
//       return {
//         notFound: true,
//       };
//     }

//     const relatedPosts = await client.query(
//       QUERY_ALL_BLOGS_SELECTIVE,
//       {
//         start: 0,
//         limit: 10,
//         sortBy: ["id:desc"],
//         filter: {},
//       },
//       {
//         requestPolicy: "network-only",
//       }
//     );

//     props = {
//       blog: sanitize(data?.blog?.data),
//       relatedPosts: Array.isArray(relatedPosts.data?.blogs?.data)
//         ? relatedPosts.data.blogs.data.map((row) => sanitize(row))
//         : [],
//     };
//   } catch (error) {
//     console.log(error);
//     return {
//       notFound: true,
//     };
//   }

//   return {
//     props,
//     revalidate: 1,
//   };
// }

export async function getServerSideProps({ params }) {
  const client = await getUrqlClient();

  try {
    const { data } = await client.query(
      QUERY_BLOG_BY_SLUG,
      { slug: params?.slug?.replace(/^blog-/, ""), },
      { requestPolicy: "network-only" }
    );

    if (!data?.blog?.data) {
      return { notFound: true };
    }

    const relatedPosts = await client.query(
      QUERY_ALL_BLOGS_SELECTIVE,
      {
        start: 0,
        limit: 10,
        sortBy: ["createdAt:desc"],
        filter: { status: "published", isActive: true },
      },
      { requestPolicy: "network-only" }
    );

    return {
      props: {
        blog: sanitize(data?.blog?.data),
        relatedPosts: Array.isArray(relatedPosts.data?.blogs?.data)
          ? relatedPosts.data.blogs.data.map((row) => sanitize(row))
          : [],
      },
    };
  } catch (error) {
    console.error(error);
    return { notFound: true };
  }
}

// export async function getStaticPaths() {
//   let paths = [];
//   const client = await getUrqlClient();
//   try {
//     const { data } = await client.query(
//       QUERY_ALL_BLOGS,
//       {
//         start: 0,
//         limit: 10,
//         sortBy: [],
//         filter: {},
//       },
//       {
//         requestPolicy: "network-only",
//       }
//     );

//     const blogs = data?.blogs?.data.map((row) => sanitize(row)) || [];

//     paths = blogs.map((blog) => {
//       return {
//         params: {
//           slug: `blog-${blog.slug}`, // Prepend `blog-`
//         },
//       };
//     });
//   } catch (error) {
//     console.log(error);
//   }
//   return {
//     paths,
//     fallback: "blocking",
//   };
// }

